export default function LineMarkersPrimitive(overlay, ctx, layout, candles) {
    
    if (candles.length < 2) return
    
    ctx.strokeStyle = overlay.lineColor
    ctx.fillStyle = overlay.markerColor
    ctx.lineWidth = overlay.lineWidth
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    
    // Draw the line first
    ctx.beginPath()
    
    // Start from the first candle
    let firstCandle = candles[0]
    ctx.moveTo(layout.t2screen(firstCandle.raw[0]), layout.$2screen(firstCandle.raw[4]))
    
    // Draw line through all candle close prices
    for (let i = 1; i < candles.length; i++) {
        let candle = candles[i]
        ctx.lineTo(layout.t2screen(candle.raw[0]), layout.$2screen(candle.raw[4]))
    }
    
    ctx.stroke()
    
    // Draw markers at each data point
    for (let i = 0; i < candles.length; i++) {
        let candle = candles[i]
        let x = layout.t2screen(candle.raw[0])
        let y = layout.$2screen(candle.raw[4])
        
        // Draw circle marker
        ctx.beginPath()
        ctx.arc(x, y, overlay.markerSize, 0, 2 * Math.PI)
        ctx.fill()
        
        // Add border to marker
        ctx.strokeStyle = overlay.lineColor
        ctx.lineWidth = 1
        ctx.stroke()
        
        // Reset line style for next iteration
        ctx.strokeStyle = overlay.lineColor
        ctx.lineWidth = overlay.lineWidth
    }
}
